export default __webpack_public_path__ + "static/media/mintingContent.12d38b3a.png";